/*
  Oeffnet und schliesst das Versandkonditionen-Popup auf der Produktseite.

  Ersetzt die frueher in templates/product.json eingebettete Variante. Die setzte
  window.onclick und btn.onclick per Zuweisung und hat damit fremde Handler auf demselben
  Element beziehungsweise auf window verworfen. Hier wird durchgehend addEventListener
  benutzt, dazu Escape zum Schliessen und ein Fokus-Rücksprung.
*/
(function () {
  'use strict';

  function start() {
    var modal = document.getElementById('shippingModal');
    var trigger = document.getElementById('openShippingPopup');
    if (!modal || !trigger) return;
    if (modal.dataset.rgwInit === '1') return;
    modal.dataset.rgwInit = '1';

    var schliessen = modal.querySelector('.shipping-close');

    // Aus dem Produktblock heraus an den Body haengen, damit kein Elternelement mit
    // overflow oder transform das fixierte Overlay beschneidet.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    function oeffnen() {
      modal.classList.add('is-offen');
      window.requestAnimationFrame(function () {
        modal.classList.add('show-modal');
      });
      if (schliessen) schliessen.focus();
    }

    function zu() {
      modal.classList.remove('show-modal');
      window.setTimeout(function () {
        modal.classList.remove('is-offen');
      }, 300);
      trigger.focus();
    }

    trigger.addEventListener('click', oeffnen);
    if (schliessen) schliessen.addEventListener('click', zu);

    modal.addEventListener('click', function (event) {
      if (event.target === modal) zu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-offen')) zu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Der Produktblock kann im Theme-Editor neu gerendert werden.
  document.addEventListener('shopify:section:load', start);
})();
